export const MODAL_KEYS = ['consultation', 'couponPrivacyProvide'] as const;

export type ModalKey = (typeof MODAL_KEYS)[number];

export function isModalKey(value: string): value is ModalKey {
  return MODAL_KEYS.includes(value as ModalKey);
}
